/**
 * SDK 版本号,单一来源。
 *
 * 构建产物(esbuild 打 src/sdk/index.ts)与文档站(Next 页面)均引用此常量,
 * 避免版本号在多处手写漂移(此前 README / showcase / 速查各写一遍)。
 */
export const VERSION = '0.3.0';
